import React, { Component } from "react";
import { ChevronLeft } from "react-feather";
import maintenaceimg from "assets/img/maintenace.png";

class maintenace extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="flex justify-center items-center top-vh-pg">
        <div>
          <img
            src={maintenaceimg}
            alt="error-404"
            className="maintenace-img-w m-auto"
          />

          <div className="mt-8 text-center">
            <p className="fsize28  text-black font-bold">
              HANG ON! We Are under maintenace
            </p>
            <div className=" mt-6 ">
              <p className="text-black fsize18 ">
                We are constantly updating our site, check back again after a
                few hoursGo Back
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default maintenace;
